import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalSpinnerService {
  private events = new Map<string, string>();
  private _show: boolean = false;
  private counter = 0;

  constructor() {}

  get show(): boolean {
    return this._show;
  }

  newEvent(description?: string): string {
    const key = String(++this.counter);
    this.addEvent(key, description);
    return key;
  }

  addEvent(key: string, description?: string): void {
    this.events.set(key, description);
    setTimeout(() => {
      this._show = this.events.size > 0;
    });
  }

  removeEvent(key: string): void {
    this.events.delete(key);
    setTimeout(() => {
      this._show = this.events.size > 0;
    });
  }

  removeAllEvent(): void {
    this.events.clear();
    setTimeout(() => {
      this._show = this.events.size > 0;
    });
  }

  logEvents(): void {
    console.log('Active Global Spinner Events: ', this.events);
  }
}
